/* eslint-disable max-lines */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Container as HomepageV2ThemeContainer } from "scmp-sdk/components/newsletter/newsletter-widget/variants/homepage-v2-theme/styles";

import { Edition } from "shared/lib/edition";
import {
  fontRoboto,
  fontRobotoCondensed,
  setFullViewportWidthStyles,
  theme,
} from "shared/lib/styles";

import {
  AdSlotContainer,
  Label as AdSlotLabel,
  Container as AdSlotOuterContainer,
  StyledSlot,
} from "scmp-app/components/advertisement/ad-slots/ad-slot/styles";
import { TakeoverAdSlot } from "scmp-app/components/advertisement/takeover-ad-slot";
import { AppFooter } from "scmp-app/components/app-footer";
import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import { ContentItemHomeNativeArticle } from "scmp-app/components/content/content-item-render/variants/home-native-article";
import {
  SponsorBox as NativeArticleSponsorBox,
  CoverImage as NativeCoverImage,
  StyledEntityLink as NativeEntityLink,
} from "scmp-app/components/content/content-item-render/variants/home-native-article/styles";
import { Button as FooterNewsletterButton } from "scmp-app/components/footer/newsletter/styles";
import { ButtonContainer as FooterSubscriptionButtonContainer } from "scmp-app/components/footer/subscription-widget/styles";
import { HomeV2Advertisers } from "scmp-app/components/home-v2/advertisers";
import { HomeV2AiArticleList } from "scmp-app/components/home-v2/ai-article-list";
import { HomeV2Around } from "scmp-app/components/home-v2/around";
import { HomeV2ChinaFutureTechStoryPackage } from "scmp-app/components/home-v2/china-future-tech-story-package";
import { HomeV2FlexiUnit } from "scmp-app/components/home-v2/flexi-unit";
import { HomeV2HeroArticles } from "scmp-app/components/home-v2/hero-articles";
import { HomeV2HeroSecondaryArticles } from "scmp-app/components/home-v2/hero-secondary-articles";
import { HomeV2Latest } from "scmp-app/components/home-v2/latest";
import { HomeV2MostPopular } from "scmp-app/components/home-v2/most-popular";
import { HomeV2Multimedia } from "scmp-app/components/home-v2/multimedia";
import { HomeV2Opinion } from "scmp-app/components/home-v2/opinion";
import { HomeV2ScmpShorts } from "scmp-app/components/home-v2/scmp-shorts";
import { HomeV2SecondaryStoryPackage } from "scmp-app/components/home-v2/secondary-story-package";
import { HomeV2SectionTop } from "scmp-app/components/home-v2/section-top";
import { HomeV2SeriesWidget } from "scmp-app/components/home-v2/series-widget";
import { HomeV2Spotlight } from "scmp-app/components/home-v2/spotlight";
import { HomeV2Subscription } from "scmp-app/components/home-v2/subscription";
import { HomeV2ThingsToDo } from "scmp-app/components/home-v2/things-to-do";
import { HomeV2TopStories } from "scmp-app/components/home-v2/top-stories";

export const Container = styled.div`
  ${setFullViewportWidthStyles}

  ${AdSlotLabel} {
    padding-block: 6px;

    color: #717171;
    font-weight: 400;
    font-size: 10px;
    font-family: ${fontRoboto};
    line-height: 12px;
    text-transform: uppercase;

    background-color: #f8f8f8;
  }
`;

export const ContentContainer = styled.div`
  inline-size: 100%;
  margin-block-start: 20px;
  margin-inline: auto;
  padding-inline: 20px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;
    padding-inline: 24px;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 1272px;
    margin-block-start: 24px;
    padding-inline: 32px;
  }
`;

type ContentWrapperProps = {
  $edition?: Edition;
  $hasPremiumNativeAd?: boolean;
};

export const ContentWrapper = styled.div<ContentWrapperProps>`
  display: grid;

  ${props => {
    switch (props.$edition) {
      case Edition.HongKong:
        return css`
          gap: 20px 0;

          ${props.$hasPremiumNativeAd
            ? css`
                grid:
                  "hero-article" min-content
                  "ads1" min-content
                  "hero-secondary" min-content
                  "top-stories" min-content
                  "nl-widget" min-content
                  "ads3" min-content
                  "flexi-unit-widget" min-content
                  "ads2" min-content
                  "opinion-widget" min-content
                  "ads5" min-content
                  "series-widget" min-content
                  "open-question-widget" min-content
                  "latest-widget" min-content
                  "cft-widget" min-content
                  "scmp-shorts" min-content
                  "ads6" min-content
                  "spotlight-widget" min-content
                  "things-to-do-widget" min-content
                  "ai-widget-1" min-content
                  "section-block-1" min-content
                  "multimedia-widget" min-content
                  "ads8" min-content
                  "section-block-2" min-content
                  "ai-widget-2" min-content
                  "subscription-widget" min-content
                  "ads10" min-content
                  "section-block-3" min-content
                  "section-block-4" min-content
                  "section-block-5" min-content
                  "most-popular-widget" min-content
                  "ads9" min-content
                  "advertisers-widget" min-content
                  "around-widget" min-content
                  / 100%;
              `
            : css`
                grid:
                  "hero-article" min-content
                  "ads1" min-content
                  "hero-secondary" min-content
                  "top-stories" min-content
                  "nl-widget" min-content
                  "ads3" min-content
                  "flexi-unit-widget" min-content
                  "opinion-widget" min-content
                  "ads5" min-content
                  "series-widget" min-content
                  "open-question-widget" min-content
                  "latest-widget" min-content
                  "cft-widget" min-content
                  "scmp-shorts" min-content
                  "ads6" min-content
                  "spotlight-widget" min-content
                  "things-to-do-widget" min-content
                  "ai-widget-1" min-content
                  "section-block-1" min-content
                  "multimedia-widget" min-content
                  "ads8" min-content
                  "section-block-2" min-content
                  "ai-widget-2" min-content
                  "subscription-widget" min-content
                  "ads10" min-content
                  "section-block-3" min-content
                  "section-block-4" min-content
                  "section-block-5" min-content
                  "most-popular-widget" min-content
                  "ads9" min-content
                  "advertisers-widget" min-content
                  "around-widget" min-content
                  / 100%;
              `}

          ${theme.breakpoints.up("tablet")} {
            gap: 24px 20px;

            ${props.$hasPremiumNativeAd
              ? css`
                  grid:
                    "hero-article hero-article" min-content
                    "hero-secondary hero-secondary" min-content
                    "ads1 ads1" min-content
                    "top-stories top-stories" min-content
                    "nl-widget nl-widget" min-content
                    "ads3 ads3" min-content
                    "flexi-unit-widget ads2" min-content
                    "opinion-widget opinion-widget" min-content
                    "ads5 ads5" min-content
                    "series-widget series-widget" min-content
                    "open-question-widget open-question-widget" min-content
                    "latest-widget latest-widget" min-content
                    "cft-widget cft-widget" min-content
                    "scmp-shorts scmp-shorts" min-content
                    "spotlight-widget spotlight-widget" min-content
                    "things-to-do-widget things-to-do-widget" min-content
                    "ads6 ads6" min-content
                    "ai-widget-1 ai-widget-1" min-content
                    "section-block-1 section-block-1" min-content
                    "section-block-2 section-block-2" min-content
                    "multimedia-widget multimedia-widget" min-content
                    "ads8 ads8" min-content
                    "ai-widget-2 ai-widget-2" min-content
                    "subscription-widget subscription-widget" min-content
                    "section-block-3 section-block-3" min-content
                    "section-block-4 section-block-4" min-content
                    "section-block-5 section-block-5" min-content
                    "most-popular-widget most-popular-widget" min-content
                    "ads9 ads9" min-content
                    "advertisers-widget advertisers-widget" min-content
                    "around-widget around-widget" min-content
                    / minmax(0, 1fr) 300px;
                `
              : css`
                  grid:
                    "hero-article" min-content
                    "hero-secondary" min-content
                    "ads1" min-content
                    "top-stories" min-content
                    "nl-widget" min-content
                    "ads3" min-content
                    "flexi-unit-widget" min-content
                    "opinion-widget" min-content
                    "ads5" min-content
                    "series-widget" min-content
                    "open-question-widget" min-content
                    "latest-widget" min-content
                    "cft-widget" min-content
                    "scmp-shorts" min-content
                    "spotlight-widget" min-content
                    "things-to-do-widget" min-content
                    "ads6" min-content
                    "ai-widget-1" min-content
                    "section-block-1" min-content
                    "section-block-2" min-content
                    "multimedia-widget" min-content
                    "ads8" min-content
                    "ai-widget-2" min-content
                    "subscription-widget" min-content
                    "section-block-3" min-content
                    "section-block-4" min-content
                    "section-block-5" min-content
                    "most-popular-widget" min-content
                    "ads9" min-content
                    "advertisers-widget" min-content
                    "around-widget" min-content
                    / 100%;
                `}
          }

          ${theme.breakpoints.up("desktop")} {
            gap: 32px 24px;

            ${props.$hasPremiumNativeAd
              ? css`
                  grid:
                    "hero-article divider-1 ads1" min-content
                    "hero-secondary divider-1 flexi-unit-widget" min-content
                    "top-stories divider-1 flexi-unit-widget" min-content
                    "top-stories divider-1 ads2" min-content
                    "top-stories divider-1 opinion-widget" min-content
                    "top-stories divider-1 ads3" min-content
                    "top-stories divider-1 ." minmax(0, 1fr)
                    "nl-widget divider-1 ." min-content
                    "ads4 ads4 ads4" min-content
                    "series-widget divider-2 latest-widget" min-content
                    "series-widget divider-2 ads5" min-content
                    "open-question-widget divider-2 ads5" min-content
                    "open-question-widget divider-2 ." min-content
                    "cft-widget divider-2 things-to-do-widget" min-content
                    "scmp-shorts divider-2 things-to-do-widget" min-content
                    "scmp-shorts divider-2 ads6" min-content
                    "spotlight-widget divider-2 ads6" min-content
                    "ads7 ads7 ads7" min-content
                    "ai-widget-1 ai-widget-1 ai-widget-1" min-content
                    "section-block-1 divider-3 multimedia-widget" min-content
                    "section-block-2 divider-3 multimedia-widget" min-content
                    "section-block-2 divider-3 ads8" min-content
                    "section-block-2 divider-3 ." minmax(0, auto)
                    "ai-widget-2 ai-widget-2 ai-widget-2" min-content
                    "subscription-widget subscription-widget subscription-widget" min-content
                    "section-block-3 divider-4 most-popular-widget" min-content
                    "section-block-3 divider-4 ads9" min-content
                    "section-block-4 divider-4 ads9" min-content
                    "section-block-5 divider-4 ." min-content
                    "advertisers-widget advertisers-widget advertisers-widget" min-content
                    "around-widget around-widget around-widget" min-content
                    / minmax(0, 1fr) 1px 300px;
                `
              : css`
                  grid:
                    "hero-article divider-1 ads1" min-content
                    "hero-secondary divider-1 flexi-unit-widget" min-content
                    "top-stories divider-1 flexi-unit-widget" min-content
                    "top-stories divider-1 opinion-widget" min-content
                    "top-stories divider-1 ads3" min-content
                    "top-stories divider-1 ." minmax(0, 1fr)
                    "nl-widget divider-1 ." min-content
                    "ads4 ads4 ads4" min-content
                    "series-widget divider-2 latest-widget" min-content
                    "series-widget divider-2 ads5" min-content
                    "open-question-widget divider-2 ads5" min-content
                    "open-question-widget divider-2 ." min-content
                    "cft-widget divider-2 things-to-do-widget" min-content
                    "scmp-shorts divider-2 things-to-do-widget" min-content
                    "scmp-shorts divider-2 ads6" min-content
                    "spotlight-widget divider-2 ads6" min-content
                    "ads7 ads7 ads7" min-content
                    "ai-widget-1 ai-widget-1 ai-widget-1" min-content
                    "section-block-1 divider-3 multimedia-widget" min-content
                    "section-block-2 divider-3 multimedia-widget" min-content
                    "section-block-2 divider-3 ads8" min-content
                    "section-block-2 divider-3 ." minmax(0, auto)
                    "ai-widget-2 ai-widget-2 ai-widget-2" min-content
                    "subscription-widget subscription-widget subscription-widget" min-content
                    "section-block-3 divider-4 most-popular-widget" min-content
                    "section-block-3 divider-4 ads9" min-content
                    "section-block-4 divider-4 ads9" min-content
                    "section-block-5 divider-4 ." min-content
                    "advertisers-widget advertisers-widget advertisers-widget" min-content
                    "around-widget around-widget around-widget" min-content
                    / minmax(0, 1fr) 1px 300px;
                `}
          }
        `;
      default:
        return css`
          gap: 20px 0;

          ${props.$hasPremiumNativeAd
            ? css`
                grid:
                  "hero-article" min-content
                  "ads1" min-content
                  "hero-secondary" min-content
                  "top-stories" min-content
                  "nl-widget" min-content
                  "ads3" min-content
                  "flexi-unit-widget" min-content
                  "ads2" min-content
                  "opinion-widget" min-content
                  "ads5" min-content
                  "series-widget" min-content
                  "open-question-widget" min-content
                  "latest-widget" min-content
                  "cft-widget" min-content
                  "scmp-shorts" min-content
                  "ads6" min-content
                  "spotlight-widget" min-content
                  "ai-widget-1" min-content
                  "section-block-1" min-content
                  "multimedia-widget" min-content
                  "ads8" min-content
                  "section-block-2" min-content
                  "ai-widget-2" min-content
                  "subscription-widget" min-content
                  "ads10" min-content
                  "section-block-3" min-content
                  "section-block-4" min-content
                  "section-block-5" min-content
                  "most-popular-widget" min-content
                  "ads9" min-content
                  "advertisers-widget" min-content
                  "around-widget" min-content
                  / 100%;
              `
            : css`
                grid:
                  "hero-article" min-content
                  "ads1" min-content
                  "hero-secondary" min-content
                  "top-stories" min-content
                  "nl-widget" min-content
                  "ads3" min-content
                  "flexi-unit-widget" min-content
                  "opinion-widget" min-content
                  "ads5" min-content
                  "series-widget" min-content
                  "open-question-widget" min-content
                  "latest-widget" min-content
                  "cft-widget" min-content
                  "scmp-shorts" min-content
                  "ads6" min-content
                  "spotlight-widget" min-content
                  "ai-widget-1" min-content
                  "section-block-1" min-content
                  "multimedia-widget" min-content
                  "ads8" min-content
                  "section-block-2" min-content
                  "ai-widget-2" min-content
                  "subscription-widget" min-content
                  "ads10" min-content
                  "section-block-3" min-content
                  "section-block-4" min-content
                  "section-block-5" min-content
                  "most-popular-widget" min-content
                  "ads9" min-content
                  "advertisers-widget" min-content
                  "around-widget" min-content
                  / 100%;
              `}

          ${theme.breakpoints.up("tablet")} {
            gap: 24px 20px;

            ${props.$hasPremiumNativeAd
              ? css`
                  grid:
                    "hero-article hero-article" min-content
                    "hero-secondary hero-secondary" min-content
                    "ads1 ads1" min-content
                    "top-stories top-stories" min-content
                    "nl-widget nl-widget" min-content
                    "ads3 ads3" min-content
                    "flexi-unit-widget ads2" min-content
                    "opinion-widget opinion-widget" min-content
                    "ads5 ads5" min-content
                    "series-widget series-widget" min-content
                    "open-question-widget open-question-widget" min-content
                    "latest-widget latest-widget" min-content
                    "cft-widget cft-widget" min-content
                    "scmp-shorts scmp-shorts" min-content
                    "spotlight-widget spotlight-widget" min-content
                    "ads6 ads6" min-content
                    "ai-widget-1 ai-widget-1" min-content
                    "section-block-1 section-block-1" min-content
                    "section-block-2 section-block-2" min-content
                    "multimedia-widget multimedia-widget" min-content
                    "ads8 ads8" min-content
                    "ai-widget-2 ai-widget-2" min-content
                    "subscription-widget subscription-widget" min-content
                    "section-block-3 section-block-3" min-content
                    "section-block-4 section-block-4" min-content
                    "section-block-5 section-block-5" min-content
                    "most-popular-widget most-popular-widget" min-content
                    "ads9 ads9" min-content
                    "advertisers-widget advertisers-widget" min-content
                    "around-widget around-widget" min-content
                    / minmax(0, 1fr) 300px;
                `
              : css`
                  grid:
                    "hero-article" min-content
                    "hero-secondary" min-content
                    "ads1" min-content
                    "top-stories" min-content
                    "nl-widget" min-content
                    "ads3" min-content
                    "flexi-unit-widget" min-content
                    "opinion-widget" min-content
                    "ads5" min-content
                    "series-widget" min-content
                    "open-question-widget" min-content
                    "latest-widget" min-content
                    "cft-widget" min-content
                    "scmp-shorts" min-content
                    "spotlight-widget" min-content
                    "ads6" min-content
                    "ai-widget-1" min-content
                    "section-block-1" min-content
                    "section-block-2" min-content
                    "multimedia-widget" min-content
                    "ads8" min-content
                    "ai-widget-2" min-content
                    "subscription-widget" min-content
                    "section-block-3" min-content
                    "section-block-4" min-content
                    "section-block-5" min-content
                    "most-popular-widget" min-content
                    "ads9" min-content
                    "advertisers-widget" min-content
                    "around-widget" min-content
                    / 100%;
                `}
          }

          ${theme.breakpoints.up("desktop")} {
            gap: 32px 24px;

            ${props.$hasPremiumNativeAd
              ? css`
                  grid:
                    "hero-article divider-1 ads1" min-content
                    "hero-secondary divider-1 flexi-unit-widget" min-content
                    "top-stories divider-1 flexi-unit-widget" min-content
                    "top-stories divider-1 ads2" min-content
                    "top-stories divider-1 opinion-widget" min-content
                    "top-stories divider-1 ads3" min-content
                    "top-stories divider-1 ." minmax(0, 1fr)
                    "nl-widget divider-1 ." min-content
                    "ads4 ads4 ads4" min-content
                    "series-widget divider-2 latest-widget" min-content
                    "series-widget divider-2 ads5" min-content
                    "open-question-widget divider-2 ads5" min-content
                    "open-question-widget divider-2 ." min-content
                    "cft-widget divider-2 ads6" min-content
                    "scmp-shorts divider-2 ads6" min-content
                    "spotlight-widget divider-2 ads6" min-content
                    "ads7 ads7 ads7" min-content
                    "ai-widget-1 ai-widget-1 ai-widget-1" min-content
                    "section-block-1 divider-3 multimedia-widget" min-content
                    "section-block-2 divider-3 multimedia-widget" min-content
                    "section-block-2 divider-3 ads8" min-content
                    "section-block-2 divider-3 ." minmax(0, auto)
                    "ai-widget-2 ai-widget-2 ai-widget-2" min-content
                    "subscription-widget subscription-widget subscription-widget" min-content
                    "section-block-3 divider-4 most-popular-widget" min-content
                    "section-block-3 divider-4 ads9" min-content
                    "section-block-4 divider-4 ads9" min-content
                    "section-block-5 divider-4 ." min-content
                    "advertisers-widget advertisers-widget advertisers-widget" min-content
                    "around-widget around-widget around-widget" min-content
                    / minmax(0, 1fr) 1px 300px;
                `
              : css`
                  grid:
                    "hero-article divider-1 ads1" min-content
                    "hero-secondary divider-1 flexi-unit-widget" min-content
                    "top-stories divider-1 flexi-unit-widget" min-content
                    "top-stories divider-1 opinion-widget" min-content
                    "top-stories divider-1 ads3" min-content
                    "top-stories divider-1 ." minmax(0, 1fr)
                    "nl-widget divider-1 ." min-content
                    "ads4 ads4 ads4" min-content
                    "series-widget divider-2 latest-widget" min-content
                    "series-widget divider-2 ads5" min-content
                    "open-question-widget divider-2 ads5" min-content
                    "open-question-widget divider-2 ." min-content
                    "cft-widget divider-2 ads6" min-content
                    "scmp-shorts divider-2 ads6" min-content
                    "spotlight-widget divider-2 ads6" min-content
                    "ads7 ads7 ads7" min-content
                    "ai-widget-1 ai-widget-1 ai-widget-1" min-content
                    "section-block-1 divider-3 multimedia-widget" min-content
                    "section-block-2 divider-3 multimedia-widget" min-content
                    "section-block-2 divider-3 ads8" min-content
                    "section-block-2 divider-3 ." minmax(0, auto)
                    "ai-widget-2 ai-widget-2 ai-widget-2" min-content
                    "subscription-widget subscription-widget subscription-widget" min-content
                    "section-block-3 divider-4 most-popular-widget" min-content
                    "section-block-3 divider-4 ads9" min-content
                    "section-block-4 divider-4 ads9" min-content
                    "section-block-5 divider-4 ." min-content
                    "advertisers-widget advertisers-widget advertisers-widget" min-content
                    "around-widget around-widget around-widget" min-content
                    / minmax(0, 1fr) 1px 300px;
                `}
          }
        `;
    }
  }}
`;

export const Divider = styled.div`
  inline-size: 0;
  block-size: 100%;
  border-inline-start: 1px #dfdfdf solid;

  ${theme.breakpoints.down("desktop")} {
    display: none;
  }
`;

export const Divider1 = styled(Divider)`
  grid-area: divider-1;
`;
export const Divider2 = styled(Divider)`
  grid-area: divider-2;
`;
export const Divider3 = styled(Divider)`
  grid-area: divider-3;
`;
export const Divider4 = styled(Divider)`
  grid-area: divider-4;
`;

export const Ads1 = styled.div`
  grid-area: ads1;

  ${theme.breakpoints.only("mobile")} {
    padding-block: 12px;
  }

  ${theme.breakpoints.down("desktop")} {
    ${setFullViewportWidthStyles}
  }
`;

export const Ads2 = styled.div`
  grid-area: ads2;

  ${theme.breakpoints.only("mobile")} {
    padding-block: 12px;
  }

  ${StyledSlot} {
    align-items: flex-start !important;
  }
`;

export const Ads3 = styled.div`
  grid-area: ads3;

  ${theme.breakpoints.only("mobile")} {
    padding-block: 12px;
  }

  ${theme.breakpoints.down("desktop")} {
    ${setFullViewportWidthStyles}
  }
`;

export const Ads4 = styled.div`
  grid-area: ads4;

  ${theme.breakpoints.down("desktop")} {
    display: none;
  }

  ${theme.breakpoints.up("desktop")} {
    ${setFullViewportWidthStyles}
    display: flex;
    justify-content: center;
    align-items: center;

    border-block: 1px solid #dfdfdf;

    ${AdSlotOuterContainer} {
      padding-block: 20px;
    }
  }
`;

export const Ads5 = styled.div`
  grid-area: ads5;

  ${theme.breakpoints.only("mobile")} {
    padding-block: 12px;
  }

  ${theme.breakpoints.down("desktop")} {
    ${setFullViewportWidthStyles}
  }
`;

export const Ads6 = styled.div`
  grid-area: ads6;

  ${theme.breakpoints.only("mobile")} {
    padding-block: 12px;
  }

  ${theme.breakpoints.down("desktop")} {
    ${setFullViewportWidthStyles}
  }
`;

export const Ads7 = styled.div`
  grid-area: ads7;

  ${theme.breakpoints.down("desktop")} {
    display: none;
  }

  ${theme.breakpoints.up("desktop")} {
    ${setFullViewportWidthStyles}
    display: flex;
    justify-content: center;
    align-items: center;

    border-block: 1px solid #dfdfdf;

    ${AdSlotOuterContainer} {
      padding-block: 20px;
    }
  }
`;

export const Ads8 = styled.div`
  grid-area: ads8;

  ${theme.breakpoints.only("mobile")} {
    padding-block: 12px;
  }

  ${theme.breakpoints.down("desktop")} {
    ${setFullViewportWidthStyles}
  }
`;

export const Ads9 = styled.div`
  grid-area: ads9;

  ${theme.breakpoints.only("mobile")} {
    padding-block: 12px;
  }

  ${theme.breakpoints.down("desktop")} {
    ${setFullViewportWidthStyles}
  }
`;

export const Ads10 = styled.div`
  grid-area: ads10;
  ${setFullViewportWidthStyles}

  ${theme.breakpoints.only("mobile")} {
    padding-block: 12px;
  }

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const HeroArticle = styled(HomeV2HeroArticles)`
  grid-area: hero-article;
`;

export const HeroSecondaryArticles = styled(HomeV2HeroSecondaryArticles)`
  grid-area: hero-secondary;

  ${theme.breakpoints.up("tablet")} {
    border-block-start: 1px #000000 solid;

    padding-block-start: 24px;
  }
`;

export const TopStories = styled(HomeV2TopStories)`
  grid-area: top-stories;
`;

export const NewsletterWidget = styled.div`
  grid-area: nl-widget;

  ${HomepageV2ThemeContainer} {
    padding-block: 12px;

    ${theme.breakpoints.only("mobile")} {
      border-block-end: 1px solid #727272;
    }

    ${theme.breakpoints.up("tablet")} {
      padding-block-start: 24px;
    }
  }
`;

export const FlexiUnitWidget = styled(HomeV2FlexiUnit)`
  grid-area: flexi-unit-widget;
`;

export const OpinionWidget = styled(HomeV2Opinion)`
  grid-area: opinion-widget;
`;

export const LatestWidget = styled(HomeV2Latest)`
  grid-area: latest-widget;
`;

export const ThingsToDoWidget = styled(HomeV2ThingsToDo)`
  grid-area: things-to-do-widget;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const SeriesWidget = styled(HomeV2SeriesWidget)`
  grid-area: series-widget;
`;

export const OpenQuestionWidget = styled(HomeV2SecondaryStoryPackage)`
  grid-area: open-question-widget;
`;

export const CFTWidget = styled(HomeV2ChinaFutureTechStoryPackage)`
  grid-area: cft-widget;
`;

export const SCMPShortsWidget = styled(HomeV2ScmpShorts)`
  grid-area: scmp-shorts;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const SpotlightWidget = styled(HomeV2Spotlight)`
  grid-area: spotlight-widget;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const AIWidget1 = styled(HomeV2AiArticleList)`
  grid-area: ai-widget-1;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const AIWidget2 = styled(HomeV2AiArticleList)`
  grid-area: ai-widget-2;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const SubscriptionWidget = styled(HomeV2Subscription)`
  grid-area: subscription-widget;

  ${theme.breakpoints.only("mobile")} {
    margin-block: 12px;
  }
`;

export const MultimediaWidget = styled(HomeV2Multimedia)`
  grid-area: multimedia-widget;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const MostPopularWidget = styled(HomeV2MostPopular)`
  grid-area: most-popular-widget;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const SectionBlock1 = styled(HomeV2SectionTop)`
  grid-area: section-block-1;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const SectionBlock2 = styled(HomeV2SectionTop)`
  grid-area: section-block-2;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const SectionBlock3 = styled(HomeV2SectionTop)`
  grid-area: section-block-3;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const SectionBlock4 = styled(HomeV2SectionTop)`
  grid-area: section-block-4;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const SectionBlock5 = styled(HomeV2SectionTop)`
  grid-area: section-block-5;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const AdvertisersWidget = styled(HomeV2Advertisers)`
  grid-area: advertisers-widget;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const AroundWidget = styled(HomeV2Around)`
  grid-area: around-widget;

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 12px;
  }
`;

export const StyledAppFooter = styled(AppFooter)`
  margin-block-start: 20px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;
  }

  ${FooterSubscriptionButtonContainer} button {
    padding-block: 8px !important;
    padding-inline: 12px !important;

    font-weight: 700;
    font-family: ${fontRobotoCondensed};

    background-color: #2c4692 !important;
  }

  ${FooterNewsletterButton} {
    padding-block: 8px;
    padding-inline: 12px;

    background-color: #2c4692;

    span {
      font-weight: 700;
      font-family: ${fontRobotoCondensed};
    }
  }
`;

export const StyledTakeoverAdSlot = styled(TakeoverAdSlot)`
  && ${AdSlotContainer} {
    inline-size: 100%;
  }

  && ${StyledSlot} > div {
    display: flex;
    flex: 1;
    justify-content: center;
  }

  ${theme.breakpoints.only("tablet")} {
    display: none;
  }
`;

export const StyledContentItemHomeNativeArticle = styled(ContentItemHomeNativeArticle)`
  ${NativeEntityLink} {
    flex-direction: row;
  }

  ${NativeArticleSponsorBox} {
    gap: 2px;
  }

  ${NativeCoverImage} {
    align-self: start;

    ${Figure} {
      inline-size: 100%;
      block-size: auto;
      aspect-ratio: 3 / 2;
    }
  }
`;
